<template>
	<div>
		<div class="content-zsy">
			<div class="column-center">
				<h3>리뷰</h3>
				<div class="head">
					<div class="member-info">
						<label>회원명</label>
						<div class="name">{{info.nickname}}</div>
					</div>
					<!-- <div class="date">{{info.createtime}}</div> -->
				</div>
				
				<div class="order-item">
					<el-row>
						<el-col :xs="24" :sm="12" style="text-align: center;" class="image-container">
							<el-image
								  style="width: 240px; height: 240px;border-radius:10px;" 
								  :src="info.goods_image"
								  fit="cover">
								  </el-image>
							<!-- 完整图片（与缩略图 src 相同，自动加载完整尺寸） -->
							<img class="full-image" :src="info.goods_image" alt=""> 
						</el-col>
						<el-col :xs="24" :sm="12" style="padding-top: 30px;">
							<div class="content-row">
								<div class="title">품목</div>
								<div class="title-value">{{info.cate_name}}</div>
							</div>
							<div class="content-row">
								<div class="title">가격</div>
								<div class="title-value">¥{{info.price}}</div>
							</div>
							<div class="content-row">
								<div class="title" >바로가기</div>
								<div class="title-value">
									<a :href="info.url" target="_blank">
										{{info.url}}
									</a>
									
								</div>
							</div>
						</el-col>
					</el-row>
					
					<div class="divided-line mt50 mb50"></div>
					
					<div class="picture-upload">
						<el-upload multiple
						  :action="update_url+'/common/upload'"
						  list-type="picture-card" :limit="4"
						  :before-upload="beforeUpload"
						  :on-success="handleSuccess"
						  :on-preview="handlePictureCardPreview"
						  :on-remove="handleRemove" :on-exceed="handlExceed">
						  <i class="el-icon-plus"></i>
						</el-upload>
						<el-dialog :visible.sync="dialogVisible">
						  <img width="100%" :src="dialogImageUrl" alt="">
						</el-dialog>
					</div>
					
					<el-input
					  type="textarea"
					  :rows="3" class="mb30" maxlength="240"
					  placeholder="댓글 내용을 입력해 주세요"
					  v-model="comment_content">
					</el-input>
					
					<div style="text-align: center;" class="mb30" >
						<el-button type="primary" round @click="onsubmit">댓글 제출</el-button>
					</div>
					
				</div>
				
			</div>
		</div>
		
		
	</div>
</template>

<script>
	import request from '@/utils/request'
	import Constants from '@/constants'
	export default {
		props: ['id'],
		data() {
			return {
				info:"",
				update_url:'',
				dialogImageUrl: '',
				dialogVisible: false,
				comment_content: '',
				image_url:[],
			};
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		mounted() {
			console.log(Constants.BASE_URL) 
			this.update_url = Constants.BASE_URL
		},
		created() {
			this.getInfo()
		},
		methods: {
			getInfo(){
				console.log(this.id,"库存商品id")
				request.post('/Comment/getGoodsInfo',{
					id:this.id
				}
				).then(res => {
					console.log(res,"信息")
					if(res.code ==1){
						this.info= res.data
					}		
				})
				
			},
			//文件上传成功时的钩子
			handleSuccess(res, file,fileList) {
				console.log(res,11)
				console.log(file,22)
				console.log(fileList,33)
				if(res.code ==1){
					// this.ruleForm.fileList=[{name: file.name, url: res.data.fullurl}]
					// this.ruleForm.license_url=res.data.url
					
					this.image_url.push(res.data.url)
				}
				//console.log(this.ruleForm.fileList,33);
	
			},
			beforeUpload(file){
				const isPt = (file.type === 'image/jpeg' || file.type === 'image/png');
				const isLt2M = file.size / 1024 / 1024 < 2;
						  
				if (!isPt) {
					this.$message.error('이미지 업로드는 JPG 또는 PNG 형식만 가능합니다!');
				}
				if (!isLt2M) {
					this.$message.error('이미지 업로드 크기는 2MB를 초과할 수 없습니다!');
				}
				return isPt && isLt2M;
			},
			//文件列表移除文件时的钩子
			handleRemove(file, fileList) {
				console.log(file, fileList);
				console.log(file.response.data.url, "删除");
				//使用 filter 创建一个不包含目标元素的新数组
				const image_url = this.image_url.filter(url => url !== file.response.data.url);
				console.log(image_url);
				this.image_url = image_url
			},
			//点击文件列表中已上传的文件时的钩子
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			handlExceed(){
				alert("이미지 업로드가 너무 많습니다")
			},
			onsubmit(){
				console.log(this.comment_content,"提交评论内容")
				console.log(this.image_url,"提交图片链接")

				if(!this.comment_content){
					alert("댓글 내용을 입력해 주세요.")
					return
				}
				request.post('/Comment/addComment',
					{
						comment_content:this.comment_content,
						image_url:this.image_url,
						commodity_id:this.info.id,
					}
				).then(response => {
					console.log(response,"返回")			  
					if(response.code ==1){
						alert('제출 성공！');				
						this.$router.push(`/reviewWriteble`)	
				
						
					}else{
						alert(response.msg)
						return
					}	
				});
				
				
			},
			
		}
		
	}
</script>

<style scoped>
	.column-center h3 {
	    text-align: center;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 60px 0 0 0;
	    margin: 0 0 60px;
	}
	.head {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    padding-bottom: 10px;
	    border-bottom: 2px solid var(--border-color);
	    margin-bottom: 40px;
	    line-height: normal;
	}
	.head .member-info {
	    display: flex;
	    align-items: center;
	}
	.head .member-info label {
	    width: 52px;
	    margin: 0;
	    font-weight: bold;
	    font-size: 15px;
	}
	.head .member-info .name {
	    background: url("../../assets/icon/ico_review_user.png") no-repeat left center;
	    padding-left: 42px;
	    line-height: 32px;
	    font-size: 12px;
	    color: var(--frontground-color);
	}
	.head .date {
	    font-size: 15px;
	    color: #5A5A5A;
	}
	.content-row{
		display: flex;align-items: center;margin: 20px 0;
	}
	.content-row .title{
		background-color: #F66D2F;width:110px;text-align: center;padding:3px 0;border-radius: 5px;color:#FFF;font-weight: bold;font-size: 14px;
	}
	.content-row .title-value{
		padding: 0 0 0 20px;
		font-size: 14px;
		color:var(--main-color);
		flex: 1; 
		word-break: break-all; 
	}
	.content-row .title-value a{
		color:var(--main-color);
		text-decoration: none;
	
	}
	.divided-line {
	    border-top: 2px solid var(--border-color);
	}
	.mb30 {
	    margin-bottom: 30px !important;
	}
	.mb50 {
	    margin-bottom: 50px !important;
	}
	.mt50 {
	    margin-top: 50px !important;
	}
	/* 完整图片样式（默认隐藏） */
	.full-image {
	  position: absolute;
	  top: 0;
	  left: 50%;
	  transform: translate(-15%, -58%); /* 居中显示 */
	  width: auto; /* 完整图片宽度（可自定义，如 500px） */
	  height: auto; /* 完整图片高度 */
	  /*max-width: 800px;  限制最大宽度，避免超出屏幕 */
	  /* max-height: 600px; */
	  opacity: 0; /* 初始透明 */
	  visibility: hidden; /* 隐藏元素（避免占用空间） */
	  transition: opacity 0.3s ease; /* 淡入淡出动画 */
	  z-index: 100; /* 确保在最上层 */
	  box-shadow: 0 0 20px rgba(0,0,0,0.3); /* 阴影效果，更美观 */
	}
	/* 鼠标悬停时显示完整图片 */
	.image-container:hover .full-image {
	  opacity: 1;
	  visibility: visible;
	}
	.picture-upload{
		padding:0 10px 30px;
	}
	
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 992px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.order-item{
			margin:0 10px;
		}
		.head {
			margin-right: 10px; 
			margin-left: 10px;
		}

		
	}
	
</style>